import BookingRequestSkeleton from "../../Components/Loader/Skeleton/BookingRequestSkeleton";
import { useEffect, useState } from "react";
import {
  _24To12,
  _HHMMSS_To_HHMM,
  decryptor,
  getMinutesFromSeconds,
  getPayloadHash,
} from "../../services/helper";
import { postFormDataCall } from "../../services/apiCall";
import { getLocalToken } from "../../services/token";
import {
  makeErrorToast,
  makeSuccessToast,
  Toast,
} from "../../Components/Toast/Toast";

const CurrentRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [bookings, setBookings] = useState([]);

  const getBookings = async () => {
    setIsLoading(true);
    const token = getLocalToken();
    let userInfo = decryptor({ encryptedData: token });
    if (!userInfo) return null;

    userInfo = JSON.parse(userInfo);

    const payload = {
      user_id: userInfo?.user_id,
      service_id: userInfo?.service_id,
    };
    let dataToSend = { data: getPayloadHash({ data: payload }) };

    let response = await postFormDataCall(
      "/get-current-bookings",
      {},
      dataToSend
    );

    if (response?.success && response?.data) {
      setBookings(response?.data?.bookings);
    }
    setIsLoading(false);
  };

  const confirmBookingHandler = async (booking_id = null) => {
    const token = getLocalToken();
    let userInfo = decryptor({ encryptedData: token });
    if (!userInfo) return null;
    if (!booking_id) return null;

    userInfo = JSON.parse(userInfo);

    const payload = {
      user_id: userInfo?.user_id,
      booking_id: booking_id,
    };
    let dataToSend = { data: getPayloadHash({ data: payload }) };

    let response = await postFormDataCall("/accept-booking", {}, dataToSend);

    if (response?.success) {
      makeSuccessToast({
        message: response?.msg,
      });
      getBookings();
    } else {
      makeErrorToast({
        message: response?.msg,
      });
    }
  };

  useEffect(() => {
    getBookings();
  }, []);

  return (
    <>
      <Toast />
      <h1 className="text-3xl font-semibold sticky top-0 bg-white z-40 py-3 border-b border-gray-300">
        Booking Requests
      </h1>
      {isLoading ? (
        <BookingRequestSkeleton />
      ) : (
        <div className="w-full mx-auto py-4">
          <div
            className={`min-h-[calc(100vh-205px)] ${
              bookings.length > 0 ? "bg-gray-100" : ""
            } p-2 rounded-md`}
          >
            {bookings.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {bookings.map((booking) => (
                  <div
                    key={booking.booking_id}
                    className="bg-white p-5 rounded-md shadow-md border border-gray-300 flex flex-col gap-2 text-gray-700"
                  >
                    <p>
                      <span className="text-gray-800 font-bold">Amount: </span>
                      <span className="text-green-500 font-bold">
                        ₹{booking.amount}
                      </span>
                    </p>
                    <p>
                      <span className="text-gray-800 font-bold">Start: </span>
                      {booking?.start_time
                        ? _24To12(_HHMMSS_To_HHMM(booking.start_time))
                        : "-"}
                    </p>
                    <p>
                      <span className="text-gray-800 font-bold">End: </span>
                      {booking?.end_time
                        ? _24To12(_HHMMSS_To_HHMM(booking.end_time))
                        : "-"}
                    </p>

                    <p className="font-medium text-gray-600">
                      Expires in{" "}
                      <span className="text-gray-700 font-bold">
                        {getMinutesFromSeconds(booking.remaining_seconds)}
                      </span>{" "}
                      mins
                    </p>

                    <div className="flex mt-1">
                      <button
                        type="button"
                        className="w-full px-4 py-2 border-2 font-bold border-blue-500 text-blue-500 rounded-md bg-blue-50 hover:scale-105 transition-all duration-100 ease-in-out"
                        onClick={() =>
                          confirmBookingHandler(booking.booking_id)
                        }
                      >
                        Accept
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img
                src="/static/image/no-data.jpg"
                alt="No Booking Requests"
                className="w-full h-96 object-contain border border-gray-300 rounded-md"
              />
            )}
          </div>
        </div>
      )}
      {/* <PopupWrapper open={confirmOpen}>
            <div className="w-full sm:w-1/2 lg:w-1/3 h-1/4 rounded-lg bg-white flex flex-col justify-between p-5 shadow-2xl shadow-gray-800">
              <div className="flex">
                <div className="flex flex-col gap-1">
                  <h6 className="text-xl font-bold text-gray-900">
                    Update Profile
                  </h6>
                  <p className="text-gray-700">
                    Are you sure you want to update your profile ?
                  </p>
                </div>
              </div>
    
              <div className="w-full flex items-center justify-end gap-2">
                <button
                  type="button"
                  className="w-20 py-1.5 rounded-lg bg-blue-50 text-blue-500 border border-blue-500 hover:scale-105 transition-all duration-150"
                  onClick={() => setConfirmOpen(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="w-24 py-1.5 rounded-lg bg-blue-500 text-white border border-blue-500 hover:scale-105 transition-all duration-150"
                  onClick={() => {
                    updateProfile();
                    setConfirmOpen(false);
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </PopupWrapper> */}
    </>
  );
};

export default CurrentRequest;
